import styled from 'styled-components'
import { spacing } from '~theme'

export const DropDownContainer = styled.div`
  margin-top: ${spacing(0.5)};
`
